import useAdminContext from '@hooks/useAdminContext';
import useQuery from '@hooks/useQuery';
import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  element: JSX.Element;
}

const AdminProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  const { authToken, loading, tokenSet } = useAdminContext();
  const query = useQuery();

  // Check if this is an MSAL redirect
  const isRedirectFromMSAL = query.get('code') && query.get('state');

  // Show loading while processing MSAL redirect or during initial load
  if (isRedirectFromMSAL || loading || !tokenSet) {
    return <div>Loading...</div>;
  }

  // If no token and not processing a redirect, go to login page
  if (!authToken) {
    return <Navigate to="/admin/login" replace />;
  }

  return element;
};

export default AdminProtectedRoute;
